import React from "react";
import { ChatBubbleIcon } from "../Dashboard/icons";

// The card sits in the billing column, so the subject saves the sender from
// typing what it is about.
const SUPPORT_MAILTO =
  "mailto:support@hostor.ai?subject=" +
  encodeURIComponent("Billing question");

export default function NeedHelpCard() {
  return (
    <section className="dash-card bill-help-card">
      <div className="bill-help-text">
        <h2 className="cz-card-title">Need help?</h2>
        <p>If you have any questions about billing or need help with your subscription.</p>
        {/* A mail client, not an in-app action: a link lets it be copied or
            opened in whichever client the browser is set to. */}
        <a
          href={SUPPORT_MAILTO}
          className="onboarding__btn onboarding__btn--secondary bill-help-btn"
        >
          Contact support
        </a>
      </div>
      <span className="bill-help-icon">
        <ChatBubbleIcon />
      </span>
    </section>
  );
}
